import type { ReactElement } from 'react';
import { Stack, type StackProps } from './stack';

type VStackProps = Omit<StackProps, 'direction'>;

/** `Stack` fixed to `direction="vertical"` — a column flexbox with the shared gap/align/justify scale. */
export const VStack = (props: VStackProps): ReactElement => (
  <Stack direction="vertical" {...props} />
);
